import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FHECard } from 'data/components';
import { withStyles, Paper } from '@material-ui/core';

class WaitingLayout extends PureComponent {
    static propTypes = {
        children: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };
    render() {
        const { children, classes } = this.props;
        return (
            <div
                className={`${classes.loginPage} d-flex flex-fill flex-column`}
                style={{
                    background: `url(${require('../../../assets/images/login-background.jpg')}) center center fixed`,
                    backgroundSize: 'cover'
                }}
            >
                <div className="d-flex flex-fill flex-column align-items-center justify-content-center p-3">
                    <div className={classes.loginLogoContainer}>
                        <img
                            className="animated jackInTheBox"
                            style={{ height: 175, width: 175 }}
                            alt="logoFHE"
                            src={require('../../../assets/images/logo_fhe.png')}
                        />
                    </div>
                    {children}
                    <Paper
                        className={`${classes.mainCard} animated fadeIn mt-5`}
                        style={{
                            position: 'relative',
                            padding: 30
                        }}
                        elevation={1}
                    >
                        <FHECard />
                    </Paper>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    loginLogoContainer: {
        paddingBottom: 30,
        left: '50%'
    },
    loginPage: {
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh'
    },
    mainCard: {
        maxWidth: '100%',
        width: 400,
        [theme.breakpoints.down('xs')]: {
            marginTop: 20
        }
    }
});

export default withStyles(styles, { withTheme: true })(WaitingLayout);



// WEBPACK FOOTER //
// ./scenes/Login/component/WaitingLayout.js